module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-ties-remnants.890638f0.png";